// Google Ads conversion (Purchase) — ID & label dari snippet Google Ads.
export const GOOGLE_ADS = {
  tagId: 'AW-11542084370',
  purchaseConversion: 'AW-11542084370/y8PWCL6C1ZUdEJL22P8q',
};

const WHATSAPP_LINK_PATTERN = /(api\.whatsapp\.com|wa\.me|whatsapp:\/\/)/i;
const LEAD_TXN_STORAGE_KEY = 'ads:lead:txn';

export function trackEvent(eventName, parameters = {}) {
  if (typeof window === 'undefined') return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...parameters });
}

// Satu transaction_id per sesi browser, supaya klik WhatsApp berulang
// dalam sesi yang sama tidak dihitung sebagai beberapa konversi oleh Google Ads.
function getLeadTransactionId() {
  try {
    const existing = window.sessionStorage.getItem(LEAD_TXN_STORAGE_KEY);
    if (existing) return existing;
    const fresh = `lead-${Date.now().toString(36)}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    window.sessionStorage.setItem(LEAD_TXN_STORAGE_KEY, fresh);
    return fresh;
  } catch {
    return `lead-${Date.now().toString(36)}`;
  }
}

// Event snippet "Purchase conversion page" dari Google Ads, dipanggil saat
// terjadi lead (klik WhatsApp / submit form) karena situs ini tidak punya
// halaman checkout.
export function trackAdsConversion(extra = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'conversion', {
    send_to: GOOGLE_ADS.purchaseConversion,
    transaction_id: getLeadTransactionId(),
    ...extra,
  });
}

function isWhatsAppHref(href) {
  return typeof href === 'string' && WHATSAPP_LINK_PATTERN.test(href);
}

// Pasang sekali di App: menangkap semua klik link WhatsApp di seluruh halaman
// (ikon melayang, footer, tombol di halaman model/blog) tanpa perlu mengubah
// setiap komponen. Mengembalikan fungsi untuk melepas listener.
export function initLeadTracking() {
  if (typeof document === 'undefined') return () => {};

  const handleClick = (event) => {
    const anchor =
      event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!anchor || !isWhatsAppHref(anchor.getAttribute('href'))) return;

    const pagePath = `${window.location.pathname}${window.location.search}`;
    const label = (anchor.textContent || anchor.getAttribute('aria-label') || '')
      .trim()
      .slice(0, 80);

    trackEvent('generate_lead', {
      method: 'whatsapp',
      page_path: pagePath,
      link_text: label || undefined,
    });
    trackAdsConversion();
  };

  document.addEventListener('click', handleClick, true);
  return () => document.removeEventListener('click', handleClick, true);
}
